document.addEventListener('DOMContentLoaded', function () {
  const cartDrawer = document.getElementById('global-cart-drawer');
  if (!cartDrawer) return;

  const closeBtn = cartDrawer.querySelector('.global-cart-close');
  const overlay = cartDrawer.querySelector('.global-cart-overlay');

  function openCartDrawer() { cartDrawer.classList.add('is-open'); }
  function closeCartDrawer() { cartDrawer.classList.remove('is-open'); }

  closeBtn.addEventListener('click', closeCartDrawer);
  overlay.addEventListener('click', closeCartDrawer);

  function updateCartPopup(cartData) {
    const itemsContainer = cartDrawer.querySelector('.global-cart-items');
    const subtotalPrice = cartDrawer.querySelector('.global-cart-subtotal-price');
    
    itemsContainer.innerHTML = '';
    
    cartData.items.forEach(item => {
      itemsContainer.innerHTML += `
        <div class="global-cart-item">
          <img src="${item.image}" alt="${item.title}">
          <div class="global-cart-item-info">
            <h4>${item.product_title}</h4>
            <p>${item.quantity} x ${(item.price / 100).toLocaleString('id-ID', { style: 'currency', currency: 'IDR' })}</p>
          </div>
        </div>
      `;
    });

    subtotalPrice.innerText = (cartData.total_price / 100).toLocaleString('id-ID', { style: 'currency', currency: 'IDR' });
    openCartDrawer();
  }

  // Menangkap SEMUA form di seluruh website yang menggunakan kelas .slider-ajax-form
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!form.classList.contains('slider-ajax-form')) return;

    e.preventDefault();

    const submitButton = form.querySelector('button[type="submit"]');
    const spinner = form.querySelector('.loading__spinner');
    const buttonText = submitButton.querySelector('span');

    if (submitButton.classList.contains('loading')) return;

    submitButton.setAttribute('aria-disabled', 'true');
    submitButton.classList.add('loading');
    if (spinner) spinner.style.display = 'inline-block';
    if (buttonText) buttonText.style.visibility = 'hidden';

    const formData = new FormData(form);

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Accept': 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    })
    .then(response => response.json())
    .then(() => {
      return fetch(window.Shopify.routes.root + 'cart.js')
        .then(res => res.json())
        .then(cart => {
          updateCartPopup(cart);

          // Update header cart count bubble jika ada
          fetch(window.Shopify.routes.root + '?section_id=header')
            .then(r => r.text())
            .then(html => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              const newBubble = doc.querySelector('#cart-icon-bubble');
              const currentBubble = document.querySelector('#cart-icon-bubble');
              if (newBubble && currentBubble) {
                currentBubble.innerHTML = newBubble.innerHTML;
              }
            });
        });
    })
    .catch(error => {
      console.error('Error:', error);
    })
    .finally(() => {
      submitButton.removeAttribute('aria-disabled');
      submitButton.classList.remove('loading');
      if (spinner) spinner.style.display = 'none';
      if (buttonText) buttonText.style.visibility = 'visible';
    });
  });
});